export default {
  createDepartmentDetails: '/departmentDetails/createDepartmentDetails',
  updateDepartmentDocument: '/departmentDetails/updateDepartmentDocument',
  updateDesignationHourForDepartmentInBulk: '/departmentDetails/updateDesignationHourForDepartmentInBulk',
  getDepartmentDetailsForInstitute: '/departmentDetails/getDepartmentDetailsForInstitute',
  deleteDepartmentDetails: '/departmentDetails/deleteDepartmentDetails',
  getDepartmentDetails: '/departmentDetails/getDepartmentDetails',

}